export const catalogMessages = {
  fr: {
    "Shop Collection": "Acheter la collection",
    "Browse the full collection of al-Malaki Ridas.": "Découvrez toute la collection de Ridas al-Malaki.",
    Collection: "Collection",
    "Explore our range of meticulously crafted Ridas.": "Explorez notre gamme de Ridas confectionnées avec soin.",
    "Search products": "Rechercher des produits",
    "Product results": "Résultats des produits",
    "Searching products": "Recherche de produits",
    "No matching products": "Aucun produit correspondant",
    "Could not load products. Please try again.": "Impossible de charger les produits. Veuillez réessayer.",
    "Retry search": "Réessayer la recherche",
    "Clear search": "Effacer la recherche",
    "Filter collection": "Filtrer la collection",
    "Close collection filters": "Fermer les filtres de collection",
    "Collection filters": "Filtres de collection",
    "Refine collection": "Affiner la collection",
    Clear: "Effacer",
    Style: "Style",
    "All Pieces": "Toutes les pièces",
    "Price range": "Fourchette de prix",
    "Only revealed prices are included.": "Seuls les prix révélés sont inclus.",
    "Available Ridas": "Ridas disponibles",
    "Ready to buy or request a remake": "Prêtes à acheter ou à recréer",
    "Share this filtered collection with anyone.": "Partagez cette collection filtrée avec tout le monde.",
    "Copy filtered collection link": "Copier le lien de la collection filtrée",
    "Filtered collection link copied.": "Lien de la collection filtrée copié.",
    "Could not copy the filtered collection link. Please try again.": "Impossible de copier le lien de la collection filtrée. Veuillez réessayer.",
    "Remake available": "Recréation disponible",
    "Buy it now": "Acheter maintenant",
    "Failed to load products. Please try again later.": "Impossible de charger les produits. Veuillez réessayer plus tard.",
    "No products found matching your criteria.": "Aucun produit ne correspond à vos critères.",
    "Clear filters": "Effacer les filtres",
    "Loading more products": "Chargement de produits supplémentaires",
    "Price on request": "Prix sur demande",
    "Sold Out": "Épuisé",
    "Sold out": "Épuisé",
    "Sold": "Vendu",
    "Request a remake": "Demander une recréation",
    "Reveal price to continue": "Révéler le prix pour continuer",
    "Adding...": "Ajout...",
    "It's gone! And Not Coming Back :(": "Cet article est épuisé et ne reviendra pas :(",
    "Tap to zoom": "Appuyez pour zoomer",
    "No image": "Aucune image",
    "Product video": "Vidéo du produit",
    "Open video viewer": "Ouvrir la vidéo en plein écran",
    "Swipe to view more": "Faites glisser pour voir plus",
    "Product not found.": "Produit introuvable.",
    "The item you are looking for does not exist or has been removed.": "L’article recherché n’existe pas ou a été supprimé.",
    "We will confirm the quote and timeline with you before payment.": "Nous confirmerons le devis et le délai avec vous avant le paiement.",
    "Add to Bag": "Ajouter au panier",
    "Share this piece": "Partager cette pièce",
    WhatsApp: "WhatsApp",
    "Share on WhatsApp": "Partager sur WhatsApp",
    "Hey, check out this beautiful piece I found on - {link}": "Salut, regarde cette belle pièce que j’ai trouvée sur - {link}",
    "Copy link": "Copier le lien",
    "Product link copied.": "Lien du produit copié.",
    "Could not copy the product link. Please try again.": "Impossible de copier le lien du produit. Veuillez réessayer.",
    "Download image": "Télécharger l’image",
    "Download image with watermark": "Télécharger l’image avec filigrane",
    "Image downloaded with al-Malaki watermark.": "Image téléchargée avec le filigrane al-Malaki.",
    "Could not download this image. Please try again.": "Impossible de télécharger cette image. Veuillez réessayer.",
    "Worn and loved.": "Porté et aimé.",
    "Customer notes": "Avis clients",
    "Customer note": "Avis client",
    "verified purchase {count} note": "avis vérifié d’un achat",
    "verified purchase {count} notes": "avis vérifiés d’un achat",
    "View image {current} of {total}": "Voir l’image {current} sur {total}",
    "Close media viewer": "Fermer la visionneuse multimédia",
    "Zoomable product image. Use pinch, wheel, or zoom controls.": "Image produit zoomable. Utilisez le pincement, la molette ou les commandes de zoom.",
    "Previous product media": "Média produit précédent",
    "Next product media": "Média produit suivant",
    "Zoom out": "Zoom arrière",
    "Zoom in": "Zoom avant",
    "Reset zoom": "Réinitialiser le zoom",
    "{current} of {total} · ": "{current} sur {total} · ",
    "Swipe to change · ": "Faites glisser pour changer · ",
    "Pinch, scroll, or double-click to zoom": "Pincez, faites défiler ou double-cliquez pour zoomer",
    "Use player controls to play this video.": "Utilisez les commandes du lecteur pour lire cette vidéo.",
    "Continue browsing": "Continuer la navigation",
    "Recently viewed": "Récemment consultés",
    "Show previous recently viewed products": "Afficher les produits récemment consultés précédents",
    "Show next recently viewed products": "Afficher les produits récemment consultés suivants",
    "View the price": "Voir le prix",
    "Enter your details and we’ll reveal the price for this piece.": "Saisissez vos coordonnées et nous révélerons le prix de cette pièce.",
    "Your name": "Votre nom",
    "Mobile number": "Numéro de mobile",
    "Country code": "Indicatif pays",
    "Featured countries": "Pays en vedette",
    "All countries": "Tous les pays",
    "Search country or calling code": "Rechercher un pays ou un indicatif téléphonique",
    "No countries found.": "Aucun pays trouvé.",
    "Select a country": "Sélectionner un pays",
    "Price unlocked": "Prix déverrouillé",
    "Your details have been saved securely.": "Vos coordonnées ont été enregistrées en toute sécurité.",
    "I’d like to receive al-Malaki new-drop announcements, offers, and styling updates on WhatsApp. I can opt out anytime.": "Je souhaite recevoir sur WhatsApp les annonces de nouveautés, offres et conseils de style d’al-Malaki. Je peux me désabonner à tout moment.",
    "We couldn’t save your details. Please try again.": "Nous n’avons pas pu enregistrer vos coordonnées. Veuillez réessayer.",
    "Saving details": "Enregistrement des coordonnées",
    "Reveal price": "Révéler le prix",
    "Your number is used to process this request. WhatsApp marketing is optional and only sent if you choose it.": "Votre numéro sert à traiter cette demande. Le marketing WhatsApp est facultatif et envoyé uniquement si vous le choisissez.",
    "Stay close": "Restez proche",
    "Join our WhatsApp Community": "Rejoignez notre communauté WhatsApp",
    "Get first looks at new Rida drops, private previews, and styling notes.": "Découvrez en avant-première les nouveautés Rida, les aperçus privés et nos conseils de style.",
    "Join community": "Rejoindre la communauté",
    "Community invite coming soon": "Invitation à la communauté bientôt disponible",
    "Image {current} of {total}": "Image {current} sur {total}",
    "Shop {title} at al-Malaki.": "Achetez {title} chez al-Malaki.",
    "{title} image {current}": "{title} image {current}",
    "{title} customer photo": "Photo client de {title}",
    "Enter a valid mobile number with country code, such as +919876543210.": "Saisissez un numéro de mobile valide avec l’indicatif du pays, par exemple +919876543210.",
    "We could not save your details. Please try again.": "Nous n’avons pas pu enregistrer vos coordonnées. Veuillez réessayer.",
    "India (+91)": "Inde (+91)",
    "UAE (+971)": "Émirats arabes unis (+971)",
    "United Kingdom (+44)": "Royaume-Uni (+44)",
    "United States / Canada (+1)": "États-Unis / Canada (+1)",
    "Australia (+61)": "Australie (+61)",
    "WhatsApp-first sign in": "Connexion par WhatsApp",
    "Code delivery method": "Mode d’envoi du code",
    Email: "E-mail",
    "WhatsApp number": "Numéro WhatsApp",
    "Enter the email used for your orders. We send the code on WhatsApp when the number matches an order or remake; otherwise, we email it.": "Saisissez l’e-mail associé à vos commandes. Nous envoyons le code sur WhatsApp si le numéro correspond à une commande ou à une demande de recréation ; sinon, nous l’envoyons par e-mail.",
    "Check WhatsApp or email for your code. If your number did not match an order or remake, we sent it by email.": "Vérifiez WhatsApp ou votre e-mail pour trouver le code. Si le numéro ne correspondait pas à une commande ou à une demande de recréation, le code a été envoyé par e-mail.",
    "Send WhatsApp code": "Envoyer le code WhatsApp",
    "Send email code": "Envoyer le code par e-mail",
    "We could not send your code. Check your details or switch to email and try again.": "Nous n’avons pas pu envoyer votre code. Vérifiez vos coordonnées ou choisissez l’e-mail et réessayez.",
    "Use a different email or WhatsApp number": "Utiliser un autre e-mail ou numéro WhatsApp",
    "WhatsApp first. Email stays available.": "WhatsApp en priorité. L’e-mail reste disponible.",
    "We send a WhatsApp code only when your number matches an order or remake tied to your email. If it does not match or WhatsApp is unavailable, we email the code.": "Nous envoyons un code WhatsApp uniquement si votre numéro correspond à une commande ou à une demande de recréation associée à votre e-mail. Sinon, ou si WhatsApp est indisponible, nous envoyons le code par e-mail.",
    "Enter your WhatsApp number. We'll send a one-time code to verify it and gather every order and remake linked to that number.": "Saisissez votre numéro WhatsApp. Nous vous enverrons un code unique pour le vérifier et réunir les commandes et demandes de recréation qui lui sont associées.",
    "Check WhatsApp for your code. Orders linked to this number stay together even when their email addresses differ.": "Consultez WhatsApp pour recevoir votre code. Les commandes liées à ce numéro restent réunies même si leurs adresses e-mail diffèrent.",
    "We could not send your code. Check the WhatsApp number and try again.": "Nous n’avons pas pu envoyer votre code. Vérifiez le numéro WhatsApp et réessayez.",
    "Use a different WhatsApp number": "Utiliser un autre numéro WhatsApp",
    "Your phone is your account.": "Votre numéro est votre compte.",
    "All orders and remakes linked to your verified number appear together, even if they used different email addresses.": "Toutes les commandes et demandes de recréation liées à votre numéro vérifié apparaissent ensemble, même si elles utilisent des adresses e-mail différentes.",
    "You have been signed out. Enter your WhatsApp number whenever you are ready to return.": "Vous êtes déconnecté. Saisissez votre numéro WhatsApp pour revenir lorsque vous le souhaitez.",
    "If your number matches an account, we will send a verification code on WhatsApp.": "Si votre numéro correspond à un compte, nous vous enverrons un code de vérification sur WhatsApp.",
    "We could not verify your account and send a code right now. Please try again shortly.": "Nous ne pouvons pas vérifier votre compte ni envoyer de code pour le moment. Veuillez réessayer bientôt.",
  } as Record<string, string>,
  ar: {
    "Shop Collection": "تسوق المجموعة",
    "Browse the full collection of al-Malaki Ridas.": "تصفح مجموعة رِدات المالكي الكاملة.",
    Collection: "المجموعة",
    "Explore our range of meticulously crafted Ridas.": "اكتشف تشكيلتنا من الردات المصممة بعناية.",
    "Search products": "ابحثي عن المنتجات",
    "Product results": "نتائج المنتجات",
    "Searching products": "جارٍ البحث عن المنتجات",
    "No matching products": "لا توجد منتجات مطابقة",
    "Could not load products. Please try again.": "تعذر تحميل المنتجات. يرجى المحاولة مرة أخرى.",
    "Retry search": "إعادة البحث",
    "Clear search": "مسح البحث",
    "Filter collection": "تصفية المجموعة",
    "Close collection filters": "إغلاق فلاتر المجموعة",
    "Collection filters": "فلاتر المجموعة",
    "Refine collection": "تخصيص المجموعة",
    Clear: "مسح",
    Style: "الأسلوب",
    "All Pieces": "كل القطع",
    "Price range": "نطاق السعر",
    "Only revealed prices are included.": "تشمل الأسعار الظاهرة فقط.",
    "Available Ridas": "ردات متاحة",
    "Ready to buy or request a remake": "جاهزة للشراء أو طلب إعادة التصنيع",
    "Share this filtered collection with anyone.": "شارك هذه المجموعة المصفاة مع أي شخص.",
    "Copy filtered collection link": "نسخ رابط المجموعة المصفاة",
    "Filtered collection link copied.": "تم نسخ رابط المجموعة المصفاة.",
    "Could not copy the filtered collection link. Please try again.": "تعذر نسخ رابط المجموعة المصفاة. يرجى المحاولة مرة أخرى.",
    "Remake available": "إعادة التصنيع متاحة",
    "Buy it now": "اشترِ الآن",
    "Failed to load products. Please try again later.": "تعذر تحميل المنتجات. يرجى المحاولة مرة أخرى لاحقًا.",
    "No products found matching your criteria.": "لم يتم العثور على منتجات مطابقة لمعاييرك.",
    "Clear filters": "مسح الفلاتر",
    "Loading more products": "جارٍ تحميل المزيد من المنتجات",
    "Price on request": "السعر عند الطلب",
    "Sold Out": "نفدت الكمية",
    "Sold out": "نفدت الكمية",
    "Sold": "مباع",
    "Request a remake": "طلب إعادة التصنيع",
    "Reveal price to continue": "أظهر السعر للمتابعة",
    "Adding...": "جارٍ الإضافة...",
    "It's gone! And Not Coming Back :(": "نفد هذا المنتج ولن يعود :(",
    "Tap to zoom": "اضغط للتكبير",
    "No image": "لا توجد صورة",
    "Product video": "فيديو المنتج",
    "Open video viewer": "فتح الفيديو بملء الشاشة",
    "Swipe to view more": "مرر لرؤية المزيد",
    "Product not found.": "المنتج غير موجود.",
    "The item you are looking for does not exist or has been removed.": "المنتج الذي تبحث عنه غير موجود أو تمت إزالته.",
    "We will confirm the quote and timeline with you before payment.": "سنؤكد السعر والجدول الزمني معك قبل الدفع.",
    "Add to Bag": "أضف إلى الحقيبة",
    "Share this piece": "شارك هذه القطعة",
    WhatsApp: "واتساب",
    "Share on WhatsApp": "شارك عبر واتساب",
    "Hey, check out this beautiful piece I found on - {link}": "مرحبًا، ألقِ نظرة على هذه القطعة الجميلة التي وجدتها على - {link}",
    "Copy link": "نسخ الرابط",
    "Product link copied.": "تم نسخ رابط المنتج.",
    "Could not copy the product link. Please try again.": "تعذر نسخ رابط المنتج. يُرجى المحاولة مرة أخرى.",
    "Download image": "تنزيل الصورة",
    "Download image with watermark": "تنزيل الصورة مع العلامة المائية",
    "Image downloaded with al-Malaki watermark.": "تم تنزيل الصورة مع العلامة المائية من al-Malaki.",
    "Could not download this image. Please try again.": "تعذر تنزيل هذه الصورة. يُرجى المحاولة مرة أخرى.",
    "Worn and loved.": "ارتُدي وأُحب.",
    "Customer notes": "ملاحظات العملاء",
    "Customer note": "ملاحظة العميل",
    "verified purchase {count} note": "ملاحظة شراء موثّقة",
    "verified purchase {count} notes": "ملاحظات شراء موثّقة",
    "View image {current} of {total}": "عرض الصورة {current} من {total}",
    "Close media viewer": "إغلاق عارض الوسائط",
    "Zoomable product image. Use pinch, wheel, or zoom controls.": "صورة منتج قابلة للتكبير. استخدم القرص أو العجلة أو أدوات التكبير.",
    "Previous product media": "وسائط المنتج السابقة",
    "Next product media": "وسائط المنتج التالية",
    "Zoom out": "تصغير",
    "Zoom in": "تكبير",
    "Reset zoom": "إعادة ضبط التكبير",
    "{current} of {total} · ": "{current} من {total} · ",
    "Swipe to change · ": "مرر للتغيير · ",
    "Pinch, scroll, or double-click to zoom": "استخدم القرص أو التمرير أو النقر المزدوج للتكبير",
    "Use player controls to play this video.": "استخدم عناصر التحكم في المشغل لتشغيل هذا الفيديو.",
    "Continue browsing": "متابعة التصفح",
    "Recently viewed": "شوهدت مؤخرًا",
    "Show previous recently viewed products": "عرض المنتجات السابقة التي شوهدت مؤخرًا",
    "Show next recently viewed products": "عرض المنتجات التالية التي شوهدت مؤخرًا",
    "View the price": "عرض السعر",
    "Enter your details and we’ll reveal the price for this piece.": "أدخل بياناتك وسنظهر سعر هذه القطعة.",
    "Your name": "اسمك",
    "Mobile number": "رقم الهاتف المحمول",
    "Country code": "رمز الدولة",
    "Featured countries": "الدول المميزة",
    "All countries": "جميع الدول",
    "Search country or calling code": "ابحث عن دولة أو رمز الاتصال",
    "No countries found.": "لم يتم العثور على دول.",
    "Select a country": "اختر دولة",
    "Price unlocked": "تم إظهار السعر",
    "Your details have been saved securely.": "تم حفظ بياناتك بأمان.",
    "I’d like to receive al-Malaki new-drop announcements, offers, and styling updates on WhatsApp. I can opt out anytime.": "أرغب في تلقي إعلانات المنتجات الجديدة والعروض وتحديثات الأناقة من المالكي عبر واتساب. يمكنني إلغاء الاشتراك في أي وقت.",
    "We couldn’t save your details. Please try again.": "تعذر حفظ بياناتك. يرجى المحاولة مرة أخرى.",
    "Saving details": "جارٍ حفظ البيانات",
    "Reveal price": "إظهار السعر",
    "Your number is used to process this request. WhatsApp marketing is optional and only sent if you choose it.": "يُستخدم رقمك لمعالجة هذا الطلب. تسويق واتساب اختياري ولا يُرسل إلا إذا اخترته.",
    "Stay close": "ابقَ قريبًا",
    "Join our WhatsApp Community": "انضم إلى مجتمعنا على واتساب",
    "Get first looks at new Rida drops, private previews, and styling notes.": "احصل على نظرة أولى على إصدارات رِدا الجديدة والمعاينات الخاصة وملاحظات الأناقة.",
    "Join community": "انضم إلى المجتمع",
    "Community invite coming soon": "دعوة المجتمع قريبًا",
    "Image {current} of {total}": "الصورة {current} من {total}",
    "Shop {title} at al-Malaki.": "تسوق {title} من المالكي.",
    "{title} image {current}": "صورة {title} رقم {current}",
    "{title} customer photo": "صورة العميل لـ {title}",
    "Enter a valid mobile number with country code, such as +919876543210.": "أدخل رقم هاتف محمول صالحًا مع رمز الدولة، مثل +919876543210.",
    "We could not save your details. Please try again.": "تعذر حفظ بياناتك. يرجى المحاولة مرة أخرى.",
    "India (+91)": "الهند (+91)",
    "UAE (+971)": "الإمارات (+971)",
    "United Kingdom (+44)": "المملكة المتحدة (+44)",
    "United States / Canada (+1)": "الولايات المتحدة / كندا (+1)",
    "Australia (+61)": "أستراليا (+61)",
    "WhatsApp-first sign in": "تسجيل الدخول عبر واتساب",
    "Code delivery method": "طريقة إرسال الرمز",
    Email: "البريد الإلكتروني",
    "WhatsApp number": "رقم واتساب",
    "Enter the email used for your orders. We send the code on WhatsApp when the number matches an order or remake; otherwise, we email it.": "أدخل البريد الإلكتروني المستخدم لطلباتك. نرسل الرمز عبر واتساب عندما يطابق الرقم طلبًا أو طلب إعادة تصنيع؛ وإلا نرسله عبر البريد الإلكتروني.",
    "Check WhatsApp or email for your code. If your number did not match an order or remake, we sent it by email.": "تحقق من واتساب أو بريدك الإلكتروني للعثور على الرمز. إذا لم يطابق رقمك طلبًا أو طلب إعادة تصنيع، فقد أرسلنا الرمز عبر البريد الإلكتروني.",
    "Send WhatsApp code": "إرسال رمز واتساب",
    "Send email code": "إرسال الرمز عبر البريد الإلكتروني",
    "We could not send your code. Check your details or switch to email and try again.": "تعذر إرسال الرمز. تحقق من بياناتك أو اختر البريد الإلكتروني وحاول مرة أخرى.",
    "Use a different email or WhatsApp number": "استخدم بريدًا إلكترونيًا أو رقم واتساب آخر",
    "WhatsApp first. Email stays available.": "واتساب أولاً، مع بقاء البريد الإلكتروني متاحًا.",
    "We send a WhatsApp code only when your number matches an order or remake tied to your email. If it does not match or WhatsApp is unavailable, we email the code.": "نرسل رمز واتساب فقط عندما يطابق رقمك طلبًا أو طلب إعادة تصنيع مرتبطًا ببريدك الإلكتروني. إذا لم يطابق أو لم يتوفر واتساب، نرسل الرمز عبر البريد الإلكتروني.",
    "Enter your WhatsApp number. We'll send a one-time code to verify it and gather every order and remake linked to that number.": "أدخل رقم واتساب الخاص بك. سنرسل رمزًا لمرة واحدة للتحقق منه وجمع جميع الطلبات وطلبات إعادة التصنيع المرتبطة به.",
    "Check WhatsApp for your code. Orders linked to this number stay together even when their email addresses differ.": "تحقق من واتساب للحصول على الرمز. ستبقى الطلبات المرتبطة بهذا الرقم مجتمعة حتى عند اختلاف عناوين البريد الإلكتروني.",
    "We could not send your code. Check the WhatsApp number and try again.": "تعذر إرسال الرمز. تحقق من رقم واتساب وحاول مرة أخرى.",
    "Use a different WhatsApp number": "استخدم رقم واتساب آخر",
    "Your phone is your account.": "رقم هاتفك هو حسابك.",
    "All orders and remakes linked to your verified number appear together, even if they used different email addresses.": "ستظهر معًا جميع الطلبات وطلبات إعادة التصنيع المرتبطة برقمك الذي تم التحقق منه، حتى لو استخدمت عناوين بريد إلكتروني مختلفة.",
    "You have been signed out. Enter your WhatsApp number whenever you are ready to return.": "تم تسجيل خروجك. أدخل رقم واتساب عندما ترغب في العودة.",
    "If your number matches an account, we will send a verification code on WhatsApp.": "إذا كان رقمك مرتبطًا بحساب، فسنرسل رمز تحقق عبر واتساب.",
    "We could not verify your account and send a code right now. Please try again shortly.": "تعذر التحقق من حسابك وإرسال الرمز الآن. يرجى المحاولة مرة أخرى بعد قليل.",
  } as Record<string, string>,
};